/** @mixin disabledCursorMixin */
/**
 * Adds disabled cursor styling to a component.
 * If there is also opacity change on the disabled styling,
 * considering using `disabledMixin` for simplicity.
 *
 * @example
 * import { disabledCursorMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${disabledCursorMixin}
 * `;
 *
 * <Component>My component with regular cursor styling</Component>
 * <Component disabled>My component with disabled cursor styling</Component>
 *
 * @method
 * @param props {object}
 * @param {boolean} [props.disabled=false] - Renders the cursor as disabled.
 * @return {CSSObject}
 */
export var disabledCursorMixin = function disabledCursorMixin(_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'cursor: default;' : '';
};